











import findPasswordPC from "./patternPC/index.vue";
import findPasswordH5 from "./patternH5/index.vue";
import { setup } from "../../utils/devicePlatform";
import Vue from "vue";
export default {
  name: "aiwen-findPassword",
  components: {
    "findPassword-pc": findPasswordPC,
    "findPassword-h5": findPasswordH5
  },
  data() {
    return {
      platformMes: {
        appVersion: "",
        systemVersion: "",
        platform: "h5",
        device: "browser",
        adapterMobile: false,
      },
    };
  },
  created() {
    (this as any).platformMes = setup();
  },
};
